import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDAButfiCpnYX938C9aJF4N-twZYeHoKZ0",
  authDomain: "tacsight-app.firebaseapp.com",
  projectId: "tacsight-app",
  storageBucket: "tacsight-app.firebasestorage.app",
  messagingSenderId: "661312399997",
  appId: "1:661312399997:web:ed50285bbda96b23e01f14"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Request permission and get token
export async function requestNotificationPermission() {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      // Get registration token
      const token = await getToken(messaging, {
        vapidKey: 'BNBL8Nh93Wkl9nLZbvLKJT3Xwi9jN0UQHzkRwM-_vkwTz7JuI6RiTFNztf0YwBZN9uvZVEEt0Uo1mhM9Q-unI_Q'
      });
      
      console.log('Token:', token);
      // Here you would typically send this token to your Rails backend
      // to store it for later use when sending notifications
      
      return token;
    }
  } catch (error) {
    console.error('Error getting permission or token:', error);
    throw error;
  }
}

// Handle foreground messages
onMessage(messaging, (payload) => {
  console.log('Received foreground message:', payload);
  // You can handle the message here, e.g., show a notification
  new Notification(payload.notification?.title ?? 'Tacsight', {
    body: payload.notification?.body ?? '',
    icon: '/apple-touch-icon.png'
  });
}); 